export const TableHelpers = {
    data() {
        return {
            tableColumns: [{
                    title: this.$t('Categoría'),
                    type: 'custom-html',
                    key: 'type',
                    modifier: (value) => {
                        // return value;
                        if(value == 'NC'){
                            return "NO CONFORMIDAD";
                        }else{
                            return "CONFORMIDAD";
                        }
                    }
                },
                {
                    title: this.$t('Requisito'),
                    type: 'custom-html',
                    key: 'requirement',
                    modifier: (value) => {
                        return value;
                    }
                },
                {
                    title: this.$t('Hallazgo'),
                    type: 'custom-html',
                    key: 'finding',
                    modifier: (value) => {
                        return value;
                    }
                },
                {
                    title: this.$t('Reiterada'),
                    type: 'custom-html',
                    key: 'repeated_after_last_evaluation',
                    modifier: (value) => {
                        if (value == 0) {
                            return "NO"
                        } else {
                            return "SI"
                        };
                    }
                },
                // {
                //     title: 'Aprobado lab',
                //     type: 'custom-html',
                //     key: 'type',
                //     modifier: (value) => {
                //         let val = value;
                //         if (val == "E") {
                //             return "EVALUACION";
                //         }
                //         if (val == "T") {
                //             return "TESTIFICACIÓN";
                //         }
                //     }       
                    
                // }, 
            ],
            actionObj: {
                title: this.$t('Acciones'),
                type: 'action',
                
            }
        }
    },
}